import { type Widget, type WidgetOrRoot } from '../../Widget.ts';

export function hasChildren(
  widget: WidgetOrRoot,
): widget is WidgetOrRoot & { children: Widget[] } {
  return 'children' in widget;
}
